{
  "columns": {
    "column": "Column",
    "actions": "Actions",
    "resetWidths": "Reset columns widths",
    "resetSorting": "Reset sorting",
    "pin": {
      "title": "Pin",
      "left": "Pin left",
      "pinnedLeft": "Pinned left",
      "right": "Pin right",
      "pinnedRight": "Pinned right"
    },
    "unpin": {
      "title": "Unpin",
      "unpinned": "Unpinned",
      "left": "Unpin left",
      "right": "Unpin right",
      "all": "Unpin all"
    },
    "showAll": "Show all columns",
    "hideAll": "Hide all columns",
    "hide": "Hide",
    "visibility": "Visibility",
    "reset": "Reset settings"
  },
  "general": {
    "autoResize": "Auto resize columns"
  },
  "loadMore": "Load more"
}